// import Main from "./pages/Main";
// import NewProduct from "./pages/NewProduct";
// import ProductList from "./pages/ProductList";
// import About from "./pages/About";
// import Navbar from "./components/Navbar";

import AppRouter from "./router/AppRouter";

function App() {
  return (
    <div>
      {/* <Navbar/>
      <Main/>
      <About/>
      <NewProduct/>
      <ProductList/> */}
      <AppRouter />
    </div>
  );
}

export default App;
